import { ErrorT, getServerApiErrorCode } from '@wellesley/error-kit'
import { FC } from 'react'
import { GreyErrorBlock } from './GreyErrorBlock'

type TooManyAttemptProps = {
  message?: string
  isError?: boolean
  error?: ErrorT
}

export const TooManyAttempt: FC<TooManyAttemptProps> = ({
  message = 'The attempt was unsuccessful, please try again',
  isError,
  error,
}) => {
  if (isError && getServerApiErrorCode(error) === 'VerificationCodeTooMany')
    return <GreyErrorBlock>{message}</GreyErrorBlock>
}
